import { useState, useRef, Fragment } from "react";
import { API_URL, translate } from "../../utils";
import Alert from "../../components/Alert";
import Input from "../../components/Input";
import Select from "../../components/Select";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

const Home = ({ lang }) => {
	const [errors, setErrors] = useState([]);
	const [names, setNames] = useState({});
	const [msg, setMsg] = useState({});

	const formElement = useRef(null);

	const handleUpdate = (name, value) => {
		setNames((names) => ({ ...names, [name]: value }));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/newsletter`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			data.append(key, value);
		});
		data.append("lang", lang);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setMsg({
					type: "success",
					text: json.text,
				});
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<Fragment>
			{msg.type && msg.type === "success" ? (
				<Alert data={msg} />
			) : (
				<Fragment>
					<form
						ref={formElement}
						method="post"
						action="/"
						onSubmit={(e) => handleSubmit(e)}
					>
						<div className="form-group">
							<Input
								name="email"
								label={translate(lang, "Email", "Correo Electrónico")}
								reqd={true}
								value={names.email || ""}
								update={handleUpdate}
								errors={errors}
							/>

							<div className="empty" />
						</div>

						<div className="form-group">
							<Select
								name="newsletter"
								label={translate(
									lang,
									"I would like to receive the monthly electronic newsletter",
									"Deseo recibir el boletín de noticias"
								)}
								reqd={true}
								value={names.newsletter || ""}
								options={[
									{ id: "", name: "--" },
									{
										id: "en",
										name: `${translate(lang, "English", "English")}`,
									},
									{
										id: "es",
										name: `${translate(lang, "Español", "Español")}`,
									},
								]}
								update={handleUpdate}
								errors={errors}
								autocomplete="off"
							/>
							<div className="empty" />
						</div>

						<div className="msg-submit" style={{ marginTop: "0" }}>
							{msg.type && <Msg data={msg} />}

							<div
								className={
									msg.type === "working" || msg.type === "success"
										? "hidden"
										: "submit-container"
								}
							>
								<Submit
									path=""
									left=""
									icon="fa fa-envelope-o"
									submit={translate(lang, "Subscribe", "Enviar")}
								/>
							</div>
						</div>
					</form>
				</Fragment>
			)}
		</Fragment>
	);
};

export default Home;
